// @flow
import { useSelector } from 'react-redux';
import { useCallback } from 'react';

export default function useFeatureFlag() {
    const features = useSelector((state: any) => state.features);

    const hasFeatureFlag = useCallback(
        (feature: string) => {
            return features[feature];
        },
        [features]
    );

    return hasFeatureFlag;
}
